import Vue from 'vue'

const mountVueComponent = function(placeholderId, component) {
    const el = document.getElementById(placeholderId)
    if (el !== undefined  && el !== null) {
        let passProps = undefined
        if (component.props) passProps = {
            props: el.dataset
        }
        new Vue({
            render: (createElement) => createElement(component, passProps)
        }).$mount(`#${placeholderId}`)
    }
}

export default mountVueComponent
